export const Common = {
  methods: {
    // 環境ごとのStripe機能のON/OFF制御
    getPaymentActiveStatus: function(hostname) {
      let isActive = true // 本番
      if (hostname === 'dev.d2q78m2xs8yfz1.amplifyapp.com') {
        isActive = true
      } else if (hostname === 'localhost') {
        isActive = false // 開発案件に応じて変更
      } else if (hostname === 'devsl.d2q78m2xs8yfz1.amplifyapp.com') {
        isActive = false
      } else if (hostname === 'devosaka.d2q78m2xs8yfz1.amplifyapp.com') {
        isActive = false
      } else if (hostname === 'devhama.d2q78m2xs8yfz1.amplifyapp.com') {
        isActive = false
      } else if (hostname.match(/^feature-.*\.d2q78m2xs8yfz1\.amplifyapp\.com$/)) {
        isActive = false
      } else if (hostname === 'design.d2q78m2xs8yfz1.amplifyapp.com') {
        isActive = true 
      } else if (hostname === 'staging.d2q78m2xs8yfz1.amplifyapp.com') {
        //isActive = true //hama状態にするため
        isActive = false
      } else if (hostname === 'sl.d2q78m2xs8yfz1.amplifyapp.com') {
        isActive = false // true禁止
      } else if (hostname === 'osaka.d2q78m2xs8yfz1.amplifyapp.com') {
        isActive = false // true禁止
      } else if (hostname === 'hama.d2q78m2xs8yfz1.amplifyapp.com') {
        isActive = false // true禁止
      } else if (hostname === 'sumitomolife.cancerwith.com') {
        isActive = false // true禁止
      } else if (hostname === 'aya.cancerwith.com') {
        isActive = false // true禁止
      } else if (hostname === 'hama.cancerwith.com') {
        isActive = false // true禁止
      }
      return isActive
    },

    // Stripeの支払い状況の有効性チェック
    getPaymentMode: function(paymentSubscriptionStatus, paymentSubscriptionStartAt, paymentSubscriptionEndAt) {
      // ベーシックプラン（課金ユーザー）の条件
      //  paymentSubscriptionStatus = paid
      //    &&
      //  paymentSubscriptionStartAt <= now < paymentSubscriptionEndAt
     
      let paymentMode = 'トライアル'

      let paymentSubscriptionStartTimestamp = new Date(paymentSubscriptionStartAt).getTime()
      let nowTimestamp = new Date().getTime()
      let paymentSubscriptionEndTimestamp = new Date(paymentSubscriptionEndAt).getTime()

      if (paymentSubscriptionStatus === 'paid' && paymentSubscriptionStartTimestamp <= nowTimestamp && nowTimestamp < paymentSubscriptionEndTimestamp) {
        paymentMode = 'ベーシックプラン'
      }

      return paymentMode
    },

    // 強制支払い済みかどうかチェック（「支払いの管理」を非表示にするかのチェックなどに利用。渋谷モニターのような無料で課金モードにしたアカウントはtrue）
    getForcePaidMode: function(paymentSubscriptionId) {
      if (paymentSubscriptionId === 'shibuya') {
        return true
      }
      return false
    },

    // 各環境のStripe用のAPIのドメイン
    getPaymentApiDomain: function(hostname) {
      let domain = 'vrot2jht66.execute-api.ap-northeast-1.amazonaws.com/master'
      if (hostname === 'dev.d2q78m2xs8yfz1.amplifyapp.com' || hostname === 'localhost') {
        domain = 'qrgcg63xxa.execute-api.ap-northeast-1.amazonaws.com/dev'
      } else if (hostname.match(/^feature-.*\.d2q78m2xs8yfz1\.amplifyapp\.com$/)) {
        domain = 'qrgcg63xxa.execute-api.ap-northeast-1.amazonaws.com/dev'
      } else if (hostname === 'design.d2q78m2xs8yfz1.amplifyapp.com') {
        domain = '1mwavy2r04.execute-api.ap-northeast-1.amazonaws.com/design'
      } else if (hostname === 'staging.d2q78m2xs8yfz1.amplifyapp.com') {
        domain = 'gwm9udkchc.execute-api.ap-northeast-1.amazonaws.com/staging'
      }
      return domain
    },

    // ベーシックプラン の商品API ID（priceID）
    getPaymentBasicPlanPriceId: function(hostname) {
      let priceId = 'price_1LaLmXBomMnPkmih9x9iEqDF' // 本番環境
      if (hostname !== 'cancerwith.com') {
        priceId = 'price_1LNzG2BomMnPkmihAYEdoRfK' // テスト環境
      }
      return priceId
    },

    // 運営による公式動作確認テストアカウント判定
    isOfficialTestAccount: function(mailAddress) {
      let officialTestAccount = this.getOfficialTestAccount()
      if (officialTestAccount.includes(mailAddress)) {
        return true
      }
      return false
    },

    // 運営による公式動作確認テストアカウントリストの取得
    getOfficialTestAccount: function() {
      let officialTestAccount = [
        'support+test1@cancerwith.com',
        'support+test2@cancerwith.com',
      ]
      return officialTestAccount
    },

    // 環境判定
    getEnv: function(hostname) {
      let env = 'prod' // 本番
      if (hostname === 'dev.d2q78m2xs8yfz1.amplifyapp.com') {
        env = 'dev'
      } else if (hostname === 'localhost') {
        env = 'dev_hama' // 開発案件に応じて変更
      } else if (hostname === 'devsl.d2q78m2xs8yfz1.amplifyapp.com') {
        env = 'dev_sl'
      } else if (hostname === 'devosaka.d2q78m2xs8yfz1.amplifyapp.com') {
        env = 'dev_osaka'
      } else if (hostname === 'devhama.d2q78m2xs8yfz1.amplifyapp.com') {
        env = 'dev_hama'
      } else if (hostname.match(/^feature-.*\.d2q78m2xs8yfz1\.amplifyapp\.com$/)) {
        env = 'feature'
      } else if (hostname === 'design.d2q78m2xs8yfz1.amplifyapp.com') {
        env = 'design'
      } else if (hostname === 'staging.d2q78m2xs8yfz1.amplifyapp.com') {
        env = 'staging'
      } else if (hostname === 'sl.d2q78m2xs8yfz1.amplifyapp.com') {
        env = 'prod_sl'
      } else if (hostname === 'osaka.d2q78m2xs8yfz1.amplifyapp.com') {
        env = 'prod_osaka'
      } else if (hostname === 'hama.d2q78m2xs8yfz1.amplifyapp.com') {
        env = 'prod_hama'
      } else if (hostname === 'sumitomolife.cancerwith.com') {
        env = 'prod_sl'
      } else if (hostname === 'aya.cancerwith.com') {
        env = 'prod_osaka'
      } else if (hostname === 'hama.cancerwith.com') {
        env = 'prod_hama'
      }
      return env
    },

    // 専用環境時の <div id="app"> に付与するクラスを取得
    getAppDivClass: function(hostname) {
      let env = this.getEnv(hostname)
      if (env === 'dev_sl' || env === 'prod_sl') {
        return 'sumitomolife'
      } else if (env === 'dev_osaka' || env === 'prod_osaka') {
        return 'osaka'
      //} else if (env === 'dev_hama' || env === 'prod_hama') {//hama状態にするため
    } else if (env === 'dev_hama' || env === 'prod_hama' || env === 'staging') {
        return 'hama'
      }
      return 
    },

    // 招待コード（ご利用コード）認証機能の状況取得
    getInvitationCodeActiveStatus: function(hostname) {
      let env = this.getEnv(hostname)
      if (env === 'dev_sl' || env === 'prod_sl' || env === 'dev_osaka' || env === 'prod_osaka') {
        return true
      }
      return false
    },

    // 招待コード（ご利用コード）認証
    getInvitationCode: function(hostname) {
      let env = this.getEnv(hostname)
      if (env === 'dev_sl' || env === 'prod_sl') {
        return ['cw-sumitomo']
      } else if (env === 'dev_osaka' || env === 'prod_osaka') {
        return ['cw-oici']
      }
      return []
    },

    // メール送信等使うサービス名を取得
    getServiceName: function(hostname) {
      let env = this.getEnv(hostname)
      if (env === 'dev_sl' || env === 'prod_sl') {
        return 'CancerWith for 住友生命'
      } else if (env === 'dev_osaka' || env === 'prod_osaka') {
        return 'CancerWith for 大阪国際がんセンター AYA世代'
      //} else if (env === 'dev_hama' || env === 'prod_hama') {//hama状態にするため
      } else if (env === 'dev_hama' || env === 'prod_hama' || env === 'staging') {
        return '浜松オンラインがん相談 for 浜松医大'
      }
      return 'CancerWith'
    },

    // ガイドモジュールに表示するアドバイザー情報の取得
    getGuideAdviser: function(hostname) {
      var guideAdviser = new Object()
      let env = this.getEnv(hostname)
      //if (env === 'dev_hama' || env === 'prod_hama') {//hama状態にするため
      if (env === 'dev_hama' || env === 'prod_hama' || env === 'staging') {
        var num = Math.floor(Math.random() * 2)
        if (num === 1) {
          guideAdviser.adviserName = '医師 柄山正人'
          guideAdviser.adviserLink = 'https://kenkyu-web.hama-med.ac.jp/Profiles/4/0000338/profile.html' //TODO変更
          guideAdviser.adviserImage = 'https://cancerwith.com/top/images/karayama.jpg'
        } else {
          guideAdviser.adviserName = '看護師 堀川明日香'
          guideAdviser.adviserLink = 'https://cancerwith.com/blog/entry/official-adviser-introduction-horikawa'
          guideAdviser.adviserImage = 'https://cancerwith.com/top/images/adviser-01.jpg'
        }
      } else {
        guideAdviser.adviserName = '看護師 堀川明日香'
        guideAdviser.adviserLink = 'https://cancerwith.com/blog/entry/official-adviser-introduction-horikawa'
        guideAdviser.adviserImage = 'https://cancerwith.com/top/images/adviser-01.jpg'
      }
      return guideAdviser

    }
  }
}

